import classNames from 'classnames';
import { FC } from 'react';

import type { SubCategoryArticle } from '@/entities/article';
import FilterResultPanel from '@/widgets/filters/ui/FilterResultPanel/FilterResultPanel';

import styles from './articleFilteredList.module.scss';
import ArticleSubCategoryList from '../ArticleSubCategoryList/ArticleSubCategoryList';

interface ArticleFilteredListProps {
  className?: string;
  value: SubCategoryArticle[];
  count: number;
  title: string;
  onClear: () => void;
}

const ArticleFilteredList: FC<ArticleFilteredListProps> = (props) => {
  const { className, value, count, title, onClear } = props;

  return (
    <section className={classNames(className, styles.container)}>
      <FilterResultPanel
        className={styles.container__head}
        count={count}
        title={title}
        onClear={onClear}
      />
      <ArticleSubCategoryList value={value} />
    </section>
  );
};

export default ArticleFilteredList;
